import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header } from "components";
import { Button } from "antd";

class UserListPage extends Component {
  render() {
    const bread = [{ text: "Liste des utilisateurs" }];

    return (
      <Fragment>
        <Helmet>{title("Liste des utilisateur")}</Helmet>

        <div className="user-list-page main-content">
          <Header title="Utilisateurs" bread={bread} />
          <List type="users" filters={{ disabled: 0 }} />
        </div>
      </Fragment>
    );
  }
}

export default UserListPage;
